import { Component, computed, effect, inject, signal } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { HelpStore } from '../../../stores/help/help.state';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { getState } from '@ngrx/signals';
import { Help } from '../../../models/help';

@Component({
  selector: 'app-help-dialog',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './help-dialog.component.html',
  styleUrl: './help-dialog.component.scss',
})
export class HelpDialogComponent {
  private readonly store = inject(HelpStore);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    // React to store changes and update `isVisible`
    effect(() => {
      const helpState = getState(this.store);
      setTimeout(() => {
        this.isVisible.set(!!this.store.activeHelpItem());
      });
    });
  }

  // Local mutable boolean for the dialog
  isVisible = signal(false);

  /**
   * Retrieves the currently active help item from the store.
   *
   * @return {Object} The active help item from the store.
   */
  get helpItem(): Help | undefined {
    return this.store.activeHelpItem();
  }

  /**
   * Retrieves the sanitized HTML content for the specified help item.
   * The content is processed to ensure it is safe for display within the application
   * by bypassing security checks and converting it into a trusted SafeHtml object.
   *
   * @return {SafeHtml} The sanitized HTML content as a SafeHtml object.
   */
  get sanitizedContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.helpItem?.content || '');
  }

  /**
   * Closes the current active help session by resetting the help key to undefined.
   *
   * @return {void} Does not return any value.
   */
  close(): void {
    this.store.setActiveHelpKey(undefined);
  }
}
